import React from 'react';
import type { AdminDashboardSummary } from '../../../models/adminDashboard';

export function MetricsCards({ summary }: { summary: AdminDashboardSummary }): React.ReactElement {
  const cards = [
    { label: 'Total companies', value: summary.totalCompanies },
    { label: 'Active companies', value: summary.activeCompanies },
    { label: 'Total merchants', value: summary.totalMerchants },
    { label: 'Active orders', value: summary.activeOrders },
  ];

  return (
    <div className="bo-admin-metrics" aria-label="Dashboard metrics">
      {cards.map((card) => (
        <div key={card.label} className="bo-card bo-admin-metric-card">
          <p className="bo-admin-metric-label">{card.label}</p>
          <p className="bo-admin-metric-value">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
